import { AxiosError } from 'axios';
import { captureException } from '../../Utils/sentryUtils';
import { FIIntegrationType } from '../../Utils/types';
import pfmClientAxiosInstance from './interceptor';

export const initiateConsent = async ({
  fipIds,
  templateType,
  consentJourneyType,
  vendor,
  fiIntegrationType,
}: {
  fipIds?: string[];
  templateType?: string[];
  consentJourneyType?: string;
  vendor?: string;
  fiIntegrationType?: FIIntegrationType;
}): Promise<any> => {
  try {
    const url = fiIntegrationType
      ? `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/consent/fi-type/${fiIntegrationType}/initiate-consent`
      : `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/consent/initiate-consent`;

    const response = await pfmClientAxiosInstance.post(url, {
      fipIds: fipIds,
      templateType: templateType,
      consentJourneyType: consentJourneyType,
      vendor: vendor,
    });

    return response;
  } catch (e: any) {
    const err = e as AxiosError;
    captureException(e);

    return {
      data: 'ERROR',
      error: err.response,
    };
  }
};
